module.exports = __webpack_public_path__ + "static/media/focus-productivity-procrastination-large@2x.8f1c7b34.png";